/** SizingTab — Conductor sizing + arc-flash calculator. */
import { ConductorSizingCard, ArcFlashCard } from "@/components/Calculators";
import SavedBatchesPanel from "@/components/SavedBatchesPanel";

export default function SizingTab({ project }) {
  return (
    <div className="space-y-6 max-w-5xl">
      <div>
        <div className="label-tag">// 05 Sizing tools</div>
        <h2 className="font-display text-2xl font-bold">Conductor & arc-flash</h2>
        <p className="text-sm text-gray-400 mt-1">
          Defaults inherit this project's voltage & code. Adjust per circuit and re-compute.
        </p>
      </div>
      <SavedBatchesPanel projectId={project.id} />
      <ConductorSizingCard
        defaults={{
          code: project.code_standard === "CEC" ? "CEC" : "NEC",
          voltage: project.voltage,
          phases: project.phases,
          load_amps: project.main_breaker_amps ? Math.round(project.main_breaker_amps * 0.8) : 80,
        }}
      />
      <ArcFlashCard defaults={{ voltage_kv: (project.voltage || 480) / 1000 }} />
    </div>
  );
}
